import { ENDPOINTS_EMPLOYEE } from 'common/endpoints/food-benefit.endpoints';
import { ENDPOINTS_MANAGER } from 'common/endpoints/food-benefit.endpoints';

class FoodBenefitService {

  constructor
  (
    FoodBenefitUserDataService,
    FoodBenefitInitialDataService,
    FoodBenefitInitialDataManagerService,
    ManagerDataService,
    $http
  )
  {
    'ngInject';
    this.initialDataService = FoodBenefitInitialDataService;
    this.ManagerDataService = ManagerDataService;
    this.userDataService = FoodBenefitUserDataService;
    this.initialDataManagerService = FoodBenefitInitialDataManagerService;
    this.http = $http;
    this.loaded = false;
    this.manager = false;
  }

  loadData() {
    if (!this.userDataService.isEmpty()) {
      return;
    }

    this._getDataFromServer();
  }

  _getDataFromServer() {
    this.loaded = false;

    this.initialDataService.initMainData().then((employee) => {
      if (!employee) return;
      this.employee = employee;
      this.manager = employee.isManager();

      if (this.manager || this.employee.hasManagerDelegation())
        this._loadManagerData();
      else
        this.loaded = true;

      return employee;
    }, () => {
      this.employee = {};
      this.manager = false;
      // TODO: [Manu] eliminado ya que probablemente sea motivo de error en la APP. Ver si en la Web es necesario o con el errorInterceptor es suficiente
      // this.state.go(STATES.ERROR);
    });
  }

  _loadManagerData() {
    if (!this.ManagerDataService.isEmpty()) {
      return;
    }

    this.getManagerDataFromServer();
  }

  getManagerDataFromServer() {
    this.loaded = false;

    this.initialDataManagerService.initMainData().then((manager) => {
      if (!manager) return;
      this.loaded = true;
      return manager;
    }, (err) => {
      this.managerData = {};
      throw(err);
    });
  }

  getManagerDataSync() {
    return this.initialDataManagerService.initMainData();
  }

  getUserDataSync() {
    return this.initialDataService.initMainData();
  }

  requestFoodBenefits(periods, employeeId) {
    return this.http.post(ENDPOINTS_EMPLOYEE.post.create(employeeId), periods).then(response => {
      return response.data;
    });
  }

  validateFoodBenefits(periods, managerId) {
    const url = ENDPOINTS_MANAGER.post.create(managerId);
    return this.http.put(url, periods).then(response => {
      return response.data;
    });
  }

}

export default FoodBenefitService;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/services/foodBenefit.service.js